import useSWR from 'swr';
import { Finstagram, SaData } from '@/types/legacyApi';
import {
  deleteDataFetcher,
  getNestedDataFetcher,
} from '@/utils/apis';
import {
  FINSTA_FEEDBACK,
  SA_APPROVAL_REJECT_CARD,
  SA_APPROVAL_REJECT_TAX,
  SA_HOLIDAY,
  SA_MONTHLY_TOTAL_PRICE,
  SA_NO_APPROVAL,
} from '@/constant/apiList';

// 전자결재 훅 — hooks/apiHooks/approval.ts 로 이동
export {
  useNewApprovalConfirmMe,
  useNewApprovalUnreadReferee,
  useNewMyApproval,
  useApprovalRecentlyViewedList,
  deleteApprovalRecentlyViewed,
} from '@/hooks/apiHooks/approval';
export type { RecentlyViewedApproval } from '@/hooks/apiHooks/approval';

export type RecentlyViewedTalkFlow = {
  talkFlowDocumentId: string;
  subject: string;
  author: {
    name: string;
    positionName: string;
  };
  createdAt: string;
};
export const useTalkFlowRecentlyViewedList = () => {
  return useSWR<RecentlyViewedTalkFlow[]>(
    '/api/v1/history/me/talk-flow/viewed/recently',
    getNestedDataFetcher,
  );
};

export const deleteTalkFlowRecentlyViewed = (talkFlowDocumentId: string) => {
  return deleteDataFetcher(
    `/api/v1/history/me/talk-flow/viewed/recently/data/${talkFlowDocumentId}`,
  );
};

export const useSaHoliday = () =>
  useSWR<SaData>(SA_HOLIDAY, getNestedDataFetcher);

export const useSaNoApproval = () =>
  useSWR<number>(SA_NO_APPROVAL, getNestedDataFetcher);

export const useSaApprovalRejectTax = () =>
  useSWR<number>(SA_APPROVAL_REJECT_TAX, getNestedDataFetcher);

export const useSaApprovalRejectCard = () =>
  useSWR<number>(SA_APPROVAL_REJECT_CARD, getNestedDataFetcher);

export const useSaMonthlyTotalPrice = () =>
  useSWR<{
    totalAmount: number;
    items: { requestAmount: number; authDate: 'string' }[];
  }>(SA_MONTHLY_TOTAL_PRICE, getNestedDataFetcher);

export const useFinstaFeedBack = () =>
  useSWR<Finstagram>(FINSTA_FEEDBACK, getNestedDataFetcher);
